import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';

function CaseOwnerSearch({ setCaseOwner, value, sessionUser, searchParam, label = 'lblCaseOwner' }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const [search, setSearch] = React.useState('');
  const { t } = useTranslation('overview');
  const [loadingText, setLoadingText] = React.useState(t('lblSearchText'));
  React.useEffect(() => {
    let active = true;
    if (open) {
      if (search.length > 4) {
        axios
          .get(
            `/GetCaseOwners/${(search || ' ')
              .toString()
              .toLocaleLowerCase(localStorage.i18nextLng_normalized)}`
          )
          .then(res => {
            if (active) {
              if (res.data) {
                setOptions(res.data);
              } else {
                setLoadingText(t('lblText'));
                setOptions([]);
              }
            }
          })
          .catch(err => {
            setOptions([]);
          });
      }
    }
    return () => {
      active = false;
    };
  }, [search, open, loading]);

  React.useEffect(() => {
    if (searchParam.length > 0) {
      setSearch(searchParam);
    }
  }, [searchParam]);

  const updateCaseOwner = item => {
    setCaseOwner(item);
    value.Dsc = item.Dsc;
    value.Id = item.Id;
  };
  return (
    <Autocomplete
      id="asynchronous-demo1"
      open={open}
      size="small"
      value={value}
      freeSolo
      disabled={!sessionUser}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
        // setCaseOwner({})
      }}
      getOptionLabel={option => {
        return option.Dsc
          ? `${option.Dsc} `
          : '';
      }}
      options={options}
      filterOptions={(options, state) => options}
      loading={loading}
      loadingText={loadingText}
      onChange={(event, newValue, reason) => {

        if (reason === "clear") {
          setCaseOwner({ Id: "", Dsc: "" });
        }

        if (newValue && newValue.Dsc) {
          setCaseOwner(newValue)
        }
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          label={t(label)}
          size="small"
          onChange={e => setSearch(e.target.value)}
          variant="outlined"
          // helperText={value ? value.Dsc : ''}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
}

export default CaseOwnerSearch;
